import React, {Fragment, useEffect, useState} from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import { Formik } from "formik";
import moment from 'moment'
import { injectIntl } from 'react-intl';
import { ACL } from '../../../../../config/constants';
import { AddCouponInCampaignModal } from "../coupon/CreateCouponModal";
import { CreateCouponSchema } from "../../../../../helpers/schemas";
import { scrollToErrors } from "../../../../../helpers/general";
import {
  COUPON_TYPE,
  DISCOUNT_TYPE
} from "../../../../../config/constants/Campaign/campaign_constants";
import { createCoupon as createCouponApi } from "../../../../../api/coupons/coupons";
import { NOTIFICATION_CREATE_COUPON } from "../../../../../config/notifications";
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';

function AddCouponInCampaignComponent(props) {
  const { campaign, setCouponCreated } = props;
  const [ toggleModal, setToggleModal ] = useState(false)
  const [ initialValues, setInitialValues ] = useState({
    no_of_coupons: '',
    prefix: '',
    type: COUPON_TYPE[0].value,
    start_date: moment().toDate(),
    end_date: moment().toDate(),
    coupon_products: [{
      product_group_id: '',
      product_id: '',
      value: undefined,
      discount_type: DISCOUNT_TYPE[0],
    }]
  });

  useEffect(() => {
    setInitialValues(values => {
      return {
        ...values,
        end_date: moment(campaign.end_date).toDate()
      }
    });
  }, [ campaign, campaign.end_date ]);

  useEffect(() => {
    if (toggleModal === false) {
      setInitialValues({
        no_of_coupons: "",
        prefix: "",
        type: COUPON_TYPE[0].value,
        start_date: moment().toDate(),
        end_date: moment(campaign.end_date).toDate(),
        coupon_products: [{
          product_group_id: '',
          product_id: '',
          value: undefined,
          discount_type: DISCOUNT_TYPE[0],
        }],
      });
    }
  },[ toggleModal, campaign.end_date ])

  const hasCampaignsEditRights = () => {
    return ACL.CLIENT.CAMPAIGNS.LIST.hasAccess() && ACL.CLIENT.CAMPAIGNS.SEARCH.hasAccess() && ACL.CLIENT.CAMPAIGNS.EDIT.hasAccess()
  }

  const hasCouponEditAccess = () => {
    return hasCampaignsEditRights() && ACL.CLIENT.COUPONS.LIST.hasAccess() && ACL.CLIENT.COUPONS.SEARCH.hasAccess() && ACL.CLIENT.COUPONS.CREATE.hasAccess();
  };

  if (! hasCouponEditAccess()) {
    return null;
  }

  const createCoupon = data => {
    data.campaign_id = campaign.id;

    if (data.prefix) {
      data.prefix = data.prefix.toUpperCase();
    }

    delete data.code;

    data.start_date = moment().format("yyyy-MM-DD");
    data.end_date = moment(campaign.end_date).format("yyyy-MM-DD");

    if (typeof data.prefix === "string" && data.prefix === "") {
      delete data.prefix;
    }

    data.coupon_products.forEach((product, index) => {
      if (data.coupon_products[index] && data.coupon_products[index].discount_type && typeof data.coupon_products[index].discount_type.value === "number") {
        data.coupon_products[index].discount_type = data.coupon_products[index].discount_type.value;
      }
    });

    createCouponApi({
      data: data,
      campaign_id: campaign.id,
      notificationId: NOTIFICATION_CREATE_COUPON,
    }).then(response => {
      if (response && response.data && response.data && response.data.length && response.data[0] && response.data[0].id) {
        setToggleModal(false);
        setCouponCreated(true);
      }
    });
  }

  return (
    <Fragment>
      <Button
        color="primary"
        size="sm"
        type="button"
        onClick={
          () => {
            store.dispatch(hideNotification());
            setToggleModal(true);
          }
        }
      >
        <FormattedMessage id="button.add_coupon" />
      </Button>
      <Formik
        key="create_coupon"
        initialValues={ initialValues }
        validationSchema={ CreateCouponSchema }
        validateOnChange={ true }
        enableReinitialize={ true }
        onSubmit={ createCoupon }
      >
        {
          formikProps => {
            scrollToErrors(formikProps);

            return <AddCouponInCampaignModal
              campaign={ campaign }
              initialValues={ initialValues }
              setInitialValues={ setInitialValues }
              formikProps={ formikProps }
              toggleModal={ toggleModal }
              setToggleModal={ setToggleModal }
              updateFormikProps={
                localFormikProps => {
                  formikProps = localFormikProps;
                }
              }
            />
          }
        }
      </Formik>
    </Fragment>
  )
}


const AddCouponInCampaign = injectIntl(AddCouponInCampaignComponent);
export { AddCouponInCampaign, AddCouponInCampaignComponent };
